<template>
  <div class="container">
    <el-container class="bsa">
      <div class="bg">
        <!-- <div class="main-logo">
        <div style="text-align:center">新网校题库管理后台</div>
      </div>
      <div class="card-page">
        <div class="main-title">用户登录</div>
        <el-form
          :model="form"
          :rules="rules"
          status-icon
          ref="ruleForm"
          label-position="left"
          label-width="0px"
        >
          <el-form-item prop="username" class="card-item card-item-username">
            <el-input
              size="medium"
              type="text"
              v-model="form.username"
              auto-complete="off"
              placeholder="用户名"
              @keyup.enter.native="login"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password" class="card-item">
            <el-input
              size="medium"
              type="password"
              v-model="form.password"
              auto-complete="off"
              placeholder="密码"
              @keyup.enter.native="login"
            ></el-input>
          </el-form-item>
          <el-form-item class="card-item">
            <el-button type="primary" class="loginBtn" @click="login">
              <span>登录</span>
            </el-button>
          </el-form-item>
          <el-form-item class="card-item card-item-findLink">
            <div class="findLink" @click="findPassword">找回密码</div>
          </el-form-item>
        </el-form>
        </div>-->
        <div class="content-left">
          <img src="../../../static/image/loginPic.png" alt />
        </div>
        <div class="content-right">
          <div class="logo">
            <!-- <img src="../../../static/image/logoVertical.png" alt /> -->
            <div style="font-size: 28px">登录</div>
          </div>
          <div class="forms">
            <el-form
              :model="form"
              :rules="rules"
              status-icon
              ref="ruleForm"
              label-position="left"
              label-width="0px"
            >
              <el-form-item
                prop="username"
                class="card-item card-item-username"
              >
                <el-input
                  size="medium"
                  type="text"
                  v-model="form.username"
                  auto-complete="off"
                  placeholder="用户名"
                  @keyup.enter.native="login"
                ></el-input>
              </el-form-item>
              <el-form-item prop="password" class="card-item">
                <el-input
                  size="medium"
                  type="password"
                  v-model="form.password"
                  auto-complete="off"
                  placeholder="密码"
                  @keyup.enter.native="login"
                ></el-input>
              </el-form-item>
              <el-form-item class="card-item">
                <el-button
                  type="primary"
                  style="
                    background: rgb(199, 0, 10);
                    border-color: rgb(199, 0, 10);
                  "
                  class="loginBtn"
                  @click="login"
                >
                  <span>登录</span>
                </el-button>
              </el-form-item>
              <el-form-item class="card-item card-item-findLink">
                <div
                  class="findLink"
                  @click="findPassword"
                  style="color: #a2aabc"
                >
                  找回密码
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <!-- <div class="footer-content">© {{format('yyyy',new Date(new Date()))}} - 弘智教育集团</div> -->
    </el-container>

    <el-dialog
      title="身份认证"
      :visible.sync="verifyVisible"
      width="490px"
      left
    >
      <Verify
        @success="verifySuccess"
        :type="verify.type"
        :mode="verify.mode"
        :vOffset="verify.vOffset"
        :vSpace="verify.vSpace"
        :explain="verify.explain"
        :imgUrl="verify.imgUrl"
        :imgName="verify.imgName"
        :imgSize="verify.imgSize"
        :blockSize="verify.blockSize"
        :barSize="verify.barSize"
        :showButton="verify.showButton"
      ></Verify>
    </el-dialog>

    <el-dialog
      title="找回密码"
      :visible.sync="findPasswordVisible"
      :close-on-click-modal="false"
      width="440px"
    >
      <el-form
        :model="findPasswordForm"
        :rules="findPasswordRules"
        status-icon
        ref="findPasswordForm"
        label-position="left"
        label-width="0px"
      >
        <el-form-item prop="mobile" class="findPassword-item">
          <el-input
            size="medium"
            type="text"
            v-model="findPasswordForm.mobile"
            auto-complete="off"
            placeholder="手机号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="code" class="findPassword-item">
          <el-input
            size="medium"
            type="text"
            v-model="findPasswordForm.code"
            auto-complete="off"
            placeholder="验证码"
            style="width: 200px"
          ></el-input>
          <el-button
            v-if="codeBtnShow"
            type="primary"
            class="sendCodeBtn"
            style="order-color: rgb(199, 0, 10)"
            @click="getCode(1)"
          >
            <!-- <span>发送验证码</span> -->
            <span>获取验证码</span>
          </el-button>
          <el-button
            v-if="!codeBtnShow"
            type="primary"
            class="sendCodeBtn"
            style="width: 116px"
          >
            <span>{{ count }} s</span>
          </el-button>
        </el-form-item>
        <el-form-item prop="password" class="findPassword-item">
          <el-input
            size="medium"
            type="password"
            v-model="findPasswordForm.password"
            auto-complete="off"
            placeholder="新密码"
            @keyup.enter.native="login"
          ></el-input>
        </el-form-item>
        <el-form-item class="findPassword-item">
          <el-button
            style="background: rgb(199, 0, 10); border-color: rgb(199, 0, 10)"
            type="primary"
            class="confirmPasswordBtn"
            @click="confirmPassword"
          >
            <span>确认</span>
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="设备授权"
      :visible.sync="deviceAuthorizeVisible"
      :close-on-click-modal="false"
      width="440px"
    >
      <el-form
        :model="deviceAuthorizeForm"
        :rules="findPasswordRules"
        status-icon
        ref="deviceAuthorizeForm"
        label-position="left"
        label-width="0px"
      >
        <el-form-item prop="mobile" class="findPassword-item">
          <el-input
            type="text"
            v-model="deviceAuthorizeForm.mobile"
            disabled
            auto-complete="off"
            placeholder="手机号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="code" class="findPassword-item">
          <el-input
            type="text"
            v-model="deviceAuthorizeForm.code"
            auto-complete="off"
            placeholder="验证码"
            style="width: 200px"
          ></el-input>
          <el-button
            v-if="codeBtnShow"
            type="primary"
            class=""
            style="width: 116px"
            @click="getCode(2)"
          >
            <span>获取验证码</span>
          </el-button>
          <el-button
            v-if="!codeBtnShow"
            type="primary"
            class=""
            style="width: 116px"
          >
            <span>{{ count }} s</span>
          </el-button>
        </el-form-item>
        <el-form-item class="findPassword-item">
          <el-button
            type="primary"
            class="confirmPasswordBtn"
            @click="confirmPassword"
          >
            <span>授权当前设备登录</span>
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Verify from "vue2-verify";

export default {
  components: {
    Verify,
  },
  data() {
    var validateMobile = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else {
        if (value !== "") {
          var reg = /^1[3456789]\d{9}$/;
          if (!reg.test(value)) {
            callback(new Error("请输入正确的手机号码"));
          }
        }
        callback();
      }
    };
    return {
      logData: {},
      verify: {
        type: 4,
        mode: "fixed",
        vOffset: 3,
        vSpace: 5,
        explain: "向右滑动完成验证",
        imgUrl: "static/image/",
        imgName: [
          "1.png",
          "2.png",
          "3.png",
          "4.png",
          "5.png",
          "6.png",
          "7.png",
          "8.png",
          "9.png",
          "10.png",
        ],
        imgSize: { width: "450px", height: "260px" },
        blockSize: { width: "40px", height: "40px" },
        barSize: { width: "450px", height: "40px" },
        showButton: false,
      },
      verifyVisible: false,
      validateCodePath: "",
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      form: {
        username: "",
        code: "",
        password: "",
      },
      buttonSize: document.body.clientWidth < 992 ? "mini" : "",
      findPasswordVisible: false,
      deviceAuthorizeVisible: false,
      deviceAuthorizeForm: {
        mobile: "",
        code: "",
      },
      findPasswordForm: {
        mobile: "",
        code: "",
        password: "",
      },
      findPasswordRules: {
        mobile: [{ validator: validateMobile, trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        password: [
          { required: true, message: "请输入新密码", trigger: "blur" },
        ],
      },
      codeBtnShow: true,
      count: "",
      timer: null,
    };
  },
  methods: {
    getGuid() {
      function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      }

      return (
        S4() +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        S4() +
        S4()
      );
    },
    changeCode() {
      this.rnd = this.getGuid();
      // this.validateCodePath =
      //   this.crmBaseUrl + "/system/validatecode/get?rnd=" + this.rnd;
    },
    login() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: "验证登录信息",
            background: "rgba(0, 0, 0, 0.7)",
          });
          this.api.system
            .login({
              username: this.form.username,
              password: this.form.password,
            })
            .then((result) => {
              if (result.success) {
                // localStorage.user = JSON.stringify(result.data);
                this.logData = result.data;
                // this.verify.imgName.push(this.images[Math.floor((Math.random( ) * this.images.length))])
                loading.close();
                if (this.logData.flag == 1) {
                  this.loginValidate();
                } else {
                  this.verifyVisible = true;
                }
              } else {
                loading.close();
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              loading.close();
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    loginValidate() {
      // const loading = this.$loading.service({
      //     lock: true,
      //     text: "验证登录信息",
      //     background: "rgba(0, 0, 0, 0.7)",
      // });
      this.$alert(
        "为保证系统安全性，需进行登录设备授权,点击确定进入授权（默认60天）操作！",
        "信息",
        {
          confirmButtonText: "确定",
          showClose: false,
          callback: (action) => {
            this.deviceAuthorizeVisible = true;
            this.deviceAuthorizeForm.mobile = this.form.username;
          },
        }
      );
    },
    verifySuccess() {
      this.$router.push({ path: "/main" });
      this.$notify({
        title: "消息",
        message: "登录成功!",
        type: "success",
        duration: 1500,
      });
      this.$store.commit("signIn", this.logData);
      this.$store.dispatch("getAuthList");
    },
    findPassword() {
      this.findPasswordForm = {
        mobile: this.form.username,
        code: "",
        password: "",
      };
      this.findPasswordVisible = true;
    },
    getCode(type) {
      let temp = "deviceAuthorizeForm";
      if (type === 1) {
        temp = "findPasswordForm";
      }
      this.$refs[temp].validateField("mobile", (errMsg) => {
        if (!errMsg) {
          this.api.system
            .getSMSCode({
              mobile: this[temp].mobile,
            })
            .then((result) => {
              if (result.success) {
                this.$message({
                  message: "短信已发送",
                  type: "success",
                });
                this.timeInterval();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
    //倒计时
    timeInterval() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.codeBtnShow = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.codeBtnShow = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    confirmPassword() {
      this.$refs.deviceAuthorizeForm.validate((valid) => {
        if (valid) {
          this.api.system
            .checkSMSCode({
              mobile: this.deviceAuthorizeForm.mobile,
              smsCode: this.deviceAuthorizeForm.code,
            })
            .then((result) => {
              if (result.success) {
                this.$message({
                  message: result.message,
                  type: "success",
                });
                this.deviceAuthorizeVisible = false;
                this.verifySuccess();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
  },
  mounted() {
    // localStorage.clear();
    this.changeCode();
    if (this.$store.state.isLogin) {
      this.$router.push(this.$route.query.redirect || "/main");
    }
  },
  computed: {
    isLogin() {
      return this.$store.state.isLogin;
    },
  },
};
</script>
<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  // background: #fff !important;
  display: flex;
  justify-content: center;
  align-items: center;
  .card-item {
    // width: 100% !important;
  }
}
.bsa {
  display: flex;
  overflow: hidden;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}
.bg {
  /* background-image: url("../../../static/image/bj.png"); */
  display: flex;
  overflow: hidden;
  justify-content: center;
  align-items: center;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  // border: 1px solid #999;
  width: 80%;
  z-index: 1111;
  // height: 80%;
  border-radius: 4px !important;
}
.content-left {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  width: 66%;

  height: 100%;
  img {
    width: 100%;
    height: auto;
  }
}
.content-right {
  width: 34%;
  height: auto;
  z-index: 111;
  // border: 1px solid #eee;
  // box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .forms {
    height: 80%;
    width: 100%;
  }
  .card-item {
    width: 80% !important;
    padding: 10% !important;
    margin: 0px !important;
    padding-bottom: 0% !important;
  }
  .el-form,
  .el-form--label-left {
    width: 100% !important;

    height: 100% !important;
  }
  .logo {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 20%;
    img {
      height: auto;
      width: 40%;
    }
  }
}

.card-page {
  -webkit-border-radius: 10px;
  border-radius: 10px;
  margin: 0 auto;
  width: 440px;
  height: 380px;
  /* padding: 30px 50px 40px 50px; */
  background: #fff;
  border: 1px solid #eaeaea;
  position: relative;
  top: 58%;
  margin-top: -220px;
}

.title {
  text-align: center;
  font-size: 20px;
}

.card-item {
  margin: 30px 60px;
  height: 48px;
  width: 320px;
}

.card-item-username {
  margin-top: 90px;
}

.card-item-findLink {
  margin-top: -20px;
}

.loginBtn {
  width: 100%;
  color: #fff;
  border-radius: 2px;
  background-color: #4d97ff;
  height: 49px;
}

.loginBtn span {
  font-size: 18px;
}

.codeImg {
  width: 80px;
  height: 40px;
  cursor: pointer;
}

.main-title {
  background-color: #4d94ff;
  height: 60px;
  width: 240px;
  position: absolute;
  top: -30px;
  left: 100px;
  color: #fff;
  font-size: 20px;
  text-align: center;
  -webkit-border-radius: 30px;
  border-radius: 30px;
  line-height: 60px;
}

.findLink {
  color: #4d97ff;
  font-size: 14px;
  text-align: center;
  cursor: pointer;
}

.main-logo {
  display: flex;
  display: -webkit-flex;
  position: absolute;
  left: calc(50% - 150px);
  top: 8%;
  height: 40px;
  line-height: 40px;
  z-index: 1111;
}

.main-logo div {
  font-size: 30px;
  width: 300px;
  color: #fff;
  align-items: center;
}

.footer-content {
  position: absolute;
  bottom: 40px;
  width: 100%;
  font-size: 12px;
  color: #fff;
  text-align: center;
}

.findPassword-item {
  margin: 30px 40px;
  height: 48px;
  white-space: nowrap;
  width: 320px;
}

.sendCodeBtn {
  color: #fff;
  border-radius: 2px;
  background-color: #4d97ff;
  height: 48px;
}

.sendCodeBtn span {
  font-size: 16px;
}

.confirmPasswordBtn {
  color: #fff;
  border-radius: 2px;
  background-color: #4d97ff;
  height: 48px;
  width: 320px;
}

.confirmPasswordBtn span {
  font-size: 18px;
}
</style>
<style>
.card-item .el-input__inner {
  border-radius: 2px;
  height: 48px;
}

.findPassword-item .el-input__inner {
  border-radius: 2px;
  height: 48px;
}
</style>



// WEBPACK FOOTER //
// src/components/login/index.vue